import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import Menu from "../Menu";

const UnclaimedPF: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div ref={contentContainerRef}>
      {/* Static Banner Section */}
      <Box
        sx={{
          width: "100%",
          height: "50vh",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), 
            url(${"/assets/service_01.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Menu isSticky={isSticky} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <Typography variant="h3" fontWeight="bold" letterSpacing={1}>
            Unclaimed Provident Fund
          </Typography>
        </Box>
      </Box>

      {/* Page Content Section */}
      <Box sx={{ padding: "40px 20px", backgroundColor: "#f9f9f9", color: "#000" }}>
        <Box sx={{ maxWidth: "900px", margin: "0 auto" }}>
          <Typography
            variant="h4"
            align="center"
            fontWeight="bold"
            gutterBottom
            sx={{ fontSize: { xs: "28px", md: "36px" }, mb: 4 }}
          >
            How to Claim Unclaimed Provident Fund
          </Typography>

          <Typography variant="body1" paragraph>
            Claiming an unclaimed Provident Fund (PF) amount involves a few simple steps:
          </Typography>

          <ul style={{ paddingLeft: "20px", marginBottom: "30px", lineHeight: "1.8" }}>
            <li>
              <Typography variant="body1">
                <strong>Locate Your PF Account Details:</strong>  
                Find your old PF account information, including your Universal Account Number (UAN) and employer details.
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>Submit a Claim Form:</strong>  
                Fill out and submit the appropriate claim form to withdraw your unclaimed amount. This can be done online or offline.
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>Online Process:</strong>  
                Visit the EPFO website, log in with your UAN, and navigate to the "Claim" section to submit your claim digitally.
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>Offline Process:</strong>  
                If you do not have a UAN, you can submit a physical claim form at the nearest EPFO office to process your request.
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>Track Claim Status:</strong>  
                After submission, track the status of your claim online through the EPFO portal.
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>Receive Payment:</strong>  
                Upon successful verification, the unclaimed PF amount will be credited directly to your registered bank account.
              </Typography>
            </li>
          </ul>

          <Typography variant="body1" paragraph>
            It is important to regularly update your UAN and bank details to ensure a smooth withdrawal process.
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default UnclaimedPF;
